import React, { useEffect, useState } from 'react'
import "./settings.scss"
import { FaQuestionCircle } from 'react-icons/fa'
import { Link, useNavigate } from 'react-router-dom'
import { MdAddCircle, MdCheckCircleOutline, MdEditSquare, MdOutlineCancel } from 'react-icons/md'
import { getAccountChannels, getAccountData, profileNameUpdate } from '../../Api'
import moment from 'moment'
import Swal from 'sweetalert2'

function Settings() {
    const navigate = useNavigate();
    const [canEdit, setCanEdit] = useState(false);
    const [newName, setNewName] = useState({first_name: '', last_name: ''});
    const [userData, setUserData] = useState(null);
    const [content, setContent] = useState(null);
    const [usedInvites, setUsedInvites] = useState(null);
    const [totalInvites, setTotalInvites] = useState(null);
    const [accountChannels, setAccountChannels] = useState([]);

    const [isPopupVisible, setPopupVisible] = useState(false);

    const handleUpgradeClick = () => {
        setPopupVisible(true);
    };

    const handleClosePopup = () => {
        setPopupVisible(false);
    };

    const update = async () => {
        Swal.fire({
            html: `<img src='/circle-1700_256.gif' style="height: 60px" alt="" />`,
            customClass: { popup: 'loader' },
            showConfirmButton: false,
            heightAuto: false
        })
        if (!newName.first_name) {
            Swal.fire({
                text: 'First name required!',
                icon: 'warning',
                iconColor: '#000',
                showConfirmButton: false,
                heightAuto: false,
                timer: 1500
            });
        }else if (!newName.last_name) {
            Swal.fire({
                text: 'Last name required!',
                icon: 'warning',
                iconColor: '#000',
                showConfirmButton: false,
                heightAuto: false,
                timer: 1500
            });
        }else{
            let res = await profileNameUpdate(userData.correl_id, {...newName});
            if (res.status === 'S') {
                Swal.fire({
                    text: 'Your Full Name updated successfully!',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 2000,
                    heightAuto: false
                })
                setCanEdit(!canEdit);
                setUserData((prev) => ({
                    ...prev,
                    first_name: res.result_info.first_name,
                    last_name: res.result_info.last_name
                }));
                setNewName({first_name: '', last_name: ''});
                localStorage.setItem(
                  "userData",
                  JSON.stringify({
                    ...userData,
                    first_name: res.result_info.first_name,
                    last_name: res.result_info.last_name
                  })
                );
            }else{
                Swal.fire({
                    text: 'Something went wrong!',
                    icon: 'warning',
                    iconColor: '#000',
                    showConfirmButton: false,
                    timer: 2000,
                    heightAuto: false
                })
            }
        }
    }

    useEffect(() => {
        (async () => {
            let userInfo = await JSON.parse(localStorage.getItem('userData') || '{}')
            setUserData(userInfo);
            let res = await getAccountData(userInfo.correl_id);
            if (res.status === 'S') {
                setContent(res.result_info);
            }
            let apiData = await getAccountChannels(userInfo.correl_id);
            if (apiData.status === 'S') {
                setAccountChannels(apiData.result_info);
            }
        })()
    }, [])

    return (
      <div className="settings-page">
        <div className="headingcontainer">
          <h5 className="heading mb-0">Account Settings</h5>
          {/* <FaQuestionCircle color='#E9C877' className='heading-icon' /> */}
        </div>
        <p className="settings-desc">
          Change account settings & billing settings
        </p>
        <div className="row mt-lg-3">
          <div className="col-12 col-lg-6">
            <div className="settings-card mb-lg-4 mb-3">
              <div className="text-start">
                {userData && (
                  <h6 className="mb-0">
                    Full Name{" "}
                    {!canEdit && (
                      <MdEditSquare
                        className="pointer"
                        role="button"
                        onClick={() => {
                          setCanEdit(!canEdit);
                          setNewName({first_name: userData.first_name, last_name: userData.last_name})
                        }}
                      />
                    )}
                  </h6>
                )}
                {userData && !canEdit && (
                  <p className="card-desc">
                    {userData.first_name}{userData.last_name ? " " + userData.last_name : ""}
                  </p>
                )}
                {userData && canEdit && (
                  <div className="d-flex mb-2 mt-1 gap-2 align-items-center">
                      <div className="form-group">
                        <input
                          type="text"
                          required={true}
                          placeholder="First Name *"
                          className="w-100"
                          value={newName.first_name}
                          onChange={(ev) => {
                            setNewName({
                              ...newName,
                              first_name: ev.target.value,
                            });
                          }}
                          label={"First name"}
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          required={true}
                          placeholder="Last name *"
                          className="w-100"
                          value={newName.last_name}
                          onChange={(ev) => {
                            setNewName({
                              ...newName,
                              last_name: ev.target.value,
                            });
                          }}
                          label={"Last Name"}
                        />
                      </div>
                    <MdCheckCircleOutline
                      className="pointer text-success"
                      role="button"
                      size={30}
                      onClick={() => {
                        // Update Api Here
                        update()
                      }}
                    />
                    <MdOutlineCancel
                      className="pointer text-danger"
                      role="button"
                      size={30}
                      onClick={() => {
                        setCanEdit(!canEdit);
                        setNewName({first_name: '', last_name: ''});
                      }}
                    />
                  </div>
                )}
                <h6 className="mb-0">Company Name</h6>
                <p className="card-desc">{userData && userData.company_name}</p>
                <h6 className="mb-0">Account Email</h6>
                <p className="card-desc">{userData && userData.email}</p>
                <h6 className="mb-2">Change Password</h6>
                <button
                  className="btn btn-black px-3 py-1 rounded-pill mb-2 text-uppercase"
                  onClick={() => {
                    navigate("/reset-password");
                  }}
                >
                  Change Password
                </button>
              </div>
            </div>
            <div className="settings-card">
              <div className="text-start">
                <h6>Review Channels</h6>
                {/* <h6 className='mb-2'>Google</h6>
                            <Link className='google-link' to='https://search.google.com/local/writereview?placeid=ChiJVVUJBGGryszRLViHIfUJqc4'>https://www.google.com/search?q=rivirtual&oq=rivirtual&gs_lcrp=EgZjaHJvbWUqCggAEAAY4wIYgAQyCggAEAAY4wIYgAQyBggBEEUYPDIGCAIQRRhBMg0IAxAuGK8BGMcBGIAEMgcIBBAAGIAEMgYIBRBFGEEyBggGEEUYPDIGCAcQRRhB0gEJMTI2NjNqMGo0qAIAsAIB&sourceid=chrome&ie=UTF-8#lrd=0x3bcb933f697df7b7:0x81be510ea5581b22,1</Link>
                            <div className="addchannelcontainer">
                                <h6 className='mb-1'>Add review channel</h6>
                                <MdAddCircle color='#E9C877' />
                            </div> */}
                {accountChannels &&
                  accountChannels.length > 0 &&
                  accountChannels.map((channel) => (
                    <div key={"channel_id-" + channel.account_channel_id}>
                      <h6 className="mt-2 mb-1">{channel.channel_name}</h6>
                      <Link
                        className="google-link"
                        target="_blank"
                        to={channel.channel_url}
                      >
                        {channel.channel_url}
                      </Link>
                    </div>
                  ))}
                <div className="addchannelcontainer d-flex align-items-center">
                  <h6 className="mb-0">Add review channel</h6>
                  <MdAddCircle
                    className="pointer"
                    onClick={() => {
                      navigate("/create-account-channel");
                    }}
                    color="#E9C877"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 mt-3 mt-lg-0">
            {content && (
              <div className="settings-card h-100">
                <div className="row">
                  <div className="col-12 col-lg-6 mb-4">
                    <h6 className="card-text">Membership</h6>
                    <div className="mt-3 card-body p-0">
                      <button className="btn btn-blue rounded-pill">
                        {userData && userData.plan}
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 mb-4">
                    <h6 className="card-text">Renewal Date</h6>
                    <p className="mt-3 mb-0">
                      {userData &&
                        moment(userData.validity_end_date).format(
                          "MMMM DD, YYYY"
                        )}
                    </p>
                  </div>
                  <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                    <h6 className="card-text">Invites Sent</h6>
                    <p className="mt-3 mb-0">
                      {String(content.usedInvites).padStart(2, "0")}/
                      {content.totalInvites}
                    </p>
                  </div>
                  <div className="col-12 col-lg-6">
                    <h6 className="card-text">Channels Used</h6>
                    <p className="mt-3 mb-0">
                      {String(content.usedChannels).padStart(2, "0")}/
                      {content.totalChannels !== "Unlimited"
                        ? "0" + content.totalChannels
                        : content.totalChannels}
                    </p>
                  </div>
                  <div className="col-12 col-lg-6 mt-4">
                    {userData &&
                      (userData.plan === "Starter" ||
                        userData.plan === "Professional") && (
                        <div>
                          <button
                            className="btn btn-black px-3 py-1 rounded-pill my-2"
                            onClick={handleUpgradeClick}
                          >
                            Upgrade Membership
                          </button>
                        </div>
                      )}
                    {userData && userData.plan === "Enterprise" && (
                      <div>
                        <button
                          className="btn btn-black px-3 py-1 rounded-pill my-2"
                          onClick={handleUpgradeClick}
                        >
                          Renew Plan
                        </button>
                      </div>
                    )}
                    {isPopupVisible && (
                      <div className="popup-overlay">
                        <div className="popup-content">
                          <img
                            src={require("../../assets/cancel-button.png")}
                            onClick={handleClosePopup}
                            className="close-btn"
                            alt=""
                          />
                          <img
                            src={require("../../assets/gr-logo.png")} // Replace with your logo URL
                            alt="Star Logo"
                            className="popup-logo"
                          />
                          <p className="popup-text">
                            Contact us at{" "}
                            <a
                              href="mailto:support@goodreviews.co"
                              className="popup-link"
                            >
                              support@goodreviews.co
                            </a>{" "}
                            for support.
                          </p>
                          <button className="ok-btn" onClick={handleClosePopup}>
                            OK
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
}

export default Settings
